import { InputHTMLAttributes } from 'react'

import { FieldError } from 'react-hook-form'

import clsx from 'clsx'

import s from './styles.module.scss'

interface Props extends InputHTMLAttributes<HTMLInputElement> {
  label?: string
  className?: string
  error?: FieldError
}

export const Radio = ({
  label,
  className,
  id,
  name,
  checked,
  disabled,
  onChange,
  error,
  ...props
}: Props) => {
  return (
    <label
      htmlFor={id}
      className={clsx(s.label, className, {
        [s.disabled]: disabled,
        [s.error]: error,
      })}
    >
      <input
        type="radio"
        id={id}
        name={name}
        checked={checked}
        disabled={disabled}
        onChange={onChange}
        className={s.input}
        {...props}
      />
      <span className={s.customRadio} />
      {label && <span className={s.labelText}>{label}</span>}
    </label>
  )
}
